import { interfaces } from 'inversify'
import { Component } from 'vue'

type SI<T> = interfaces.ServiceIdentifier<T>

interface RelationSportOptionalIoCBindingsInterface {
  EventStats: SI<Component>
}

export const RelationSportOptionalIoCBindings: RelationSportOptionalIoCBindingsInterface =
  {
    EventStats: Symbol('EventStats'),
  }
